import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=1a06974a&scoped=true"
import script from "./FlagIcon.vue?vue&type=script&lang=js"
export * from "./FlagIcon.vue?vue&type=script&lang=js"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=1a06974a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a06974a",
  null
  
)

export default component.exports